import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Button, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Skeleton, Switch, Select, MenuItem, FormControl, InputLabel, TextField, RadioGroup, FormControlLabel, Radio, Grid } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { SHARE_LEVEL_MAP, USER_LEVELS, USER_LEVEL_MAP } from "src/config/constants";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserPicker from "src/components/common/UserPicker";
import Cascader from "src/components/cascader/Cascader";
import { useSelector } from "react-redux";
import { getAreas } from "src/services/request";
import CityPicker from "src/components/CityPicker";

const levels = Object.values(USER_LEVELS);

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "user", label: "会员", alignRight: false },
  { id: "realname", label: "真实姓名", alignRight: false },
  { id: "mobile", label: "手机号", alignRight: false },
  // { id: "level", label: "等级", alignRight: false },
  { id: "type", label: "类型", alignRight: false },
  // { id: "balance", label: "绩效", alignRight: false },
  // { id: "canWithdraw", label: "可激活消费券", alignRight: false },
  // { id: "enableButie", label: "直营补贴", alignRight: false },
  // { id: "sharer", label: "推荐人", alignRight: false },
  // { id: "buzhang", label: "部长", alignRight: false },
  // { id: "dudao", label: "督导", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "" },
];
const moreMenus = [{ title: "编辑", icon: iconEdit2 },{ title: "删除", icon: iconEdit2 }];

export default function ShareholderList() {
  const { areas, areaHierarchy } = useSelector((state) => state.globalData);
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [action, setAction] = useState("");
  const [targetItem, setTaretItem] = useState({});
  const [user, setUser] = useState({});
  const [sharer, setSharer] = useState({});

  const [form, setForm] = useState({
    realname: "",
    type: 1,
    status: 1,
  });

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    type: null,
  });

  useEffect(() => {
    // getAreas();
  }, []);

  useEffect(() => {
    getItems();
  }, [filter]);

  function handleRefresh() {
    setItems(null);
    getItems();
  }

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/shareholder/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setTaretItem(row);
      setForm({
        ...row,
      });
      setUser(row.user);
      setSharer(row.sharer || {});
      setAction("edit");
      // navigate(`/user/edit/${row.uid}`, { state: row });
    }
    if (type === "删除") {

      handleDelAgent({id:row.id});

    }
  };

  // 新增
  function handleAddItem() {
    setAction("add");
    setForm({
      realname: "",
      status: 1,
    });
    setUser({});
    setSharer({});
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSelectUser(ki) {
    UserPicker({
      onSelect(val) {
        // console.log(val);
        switch (ki) {
          case "uid":
            setUser(val);
            break;
          case "sharerUid":
            setSharer(val);
            break;
        }
      },
    });
  }

  async function handleDialogConfirm() {
    const { mobile, realname } = form;
    if (!mobile || !realname) return alert("信息不全");
    if (!user) return alert("请选择用户");

    const formData = {
      mobile,
      realname,
      uid: user.uid,
      sharerUid: sharer.uid,
    };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    const { data } = await asyncRequest({
      path: action === "add" ? "/shareholder/add" : "/shareholder/edit",
      data: formData,
    });
    getItems();
    setAction("");
  }

  async function handleEditAgent(formData) {
    const { data } = await asyncRequest({
      path: "/shareholder/edit",
      data: formData,
    });

    getItems();
  }

  async function handleDelAgent(formData) {
    const { data } = await asyncRequest({
      path: "/shareholder/delete",
      data: formData,
    });

    getItems();
  }

  return (
    <Page title="联创列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            联创列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddItem}>
            添加联创
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={handleRefresh}>
            <Grid container gap={1}>
              <Grid item sm={6} md={3}>
                <TextField
                  style={{ width: 200 }}
                  label="用户ID"
                  size="small"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  style={{ width: 200 }}
                  label="手机号"
                  size="small"
                  placeholder="手机号"
                  autoComplete="off"
                  id="mobile"
                  value={filter.mobile}
                  onChange={(e) => {
                    handleFilterChange("mobile", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl>
                  <InputLabel id="demo-simple-select-label" size="small">
                    类型
                  </InputLabel>
                  <Select
                    // labelId="demo-simple-select-label"
                    // id="demo-simple-select"
                    label="类型"
                    size="small"
                    value={filter.type}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        type: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[null, 1, 2].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {idx == 0 ? "全部" : ["", "合伙人", "代言人"][type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {!items ? (
                    <TableRow>
                      <TableCell align="center" colSpan={TABLE_HEAD.length} sx={{ py: 5 }}>
                        <Stack spacing={1} padding={2}>
                          <Skeleton variant="rectangular" animation="wave" height={30} />
                          <Skeleton variant="rectangular" animation="wave" height={30} />
                          <Skeleton variant="rectangular" animation="wave" height={30} />
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ) : items.length === 0 ? (
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    <>
                      {items.map((row) => {
                        const { id, user, realname, uid, city, district, mobile, share, createdAt, type, buzhang, dudao, sharer, balance, canWithdraw, level, fromMer } = row;
                        const isItemSelected = selected.indexOf(realname) !== -1;

                        return (
                          <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                            {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}
                            <TableCell align="left">{id}</TableCell>
                            <TableCell align="left">{uid}</TableCell>
                            {/* <TableCell component="th" scope="row">
                              <UserInfo {...user} enablePreview />
                            </TableCell> */}
                            <TableCell align="left">{realname}</TableCell>
                            <TableCell align="left">{mobile}</TableCell>
                            <TableCell align="left">{["", "合伙人", "代言人"][type]}</TableCell>
                            {/* <TableCell align="left">
                              {province}
                              {city}
                              {district}
                            </TableCell> */}
                            {/* <TableCell align="left">{StringUtil.toFixed2(balance)}</TableCell> */}

                            {/* <TableCell align="left">
                              <Switch checked={canWithdraw} onChange={(e) => handleEditAgent({ id: row.id, canWithdraw: !canWithdraw })} />
                            </TableCell>

                            <TableCell align="left">
                              <Switch checked={enableButie} onChange={(e) => handleEditAgent({ id: row.id, enableButie: !enableButie })} />
                            </TableCell> */}

                            {/* <TableCell component="th" scope="row">
                              {sharer ? <UserInfo {...sharer} enablePreview /> : null}
                            </TableCell> */}

                            {/* <TableCell component="th" scope="row">
                              {buzhang ? <UserInfo {...buzhang} enablePreview /> : null}
                            </TableCell>

                            <TableCell component="th" scope="row">
                              {dudao ? <UserInfo {...dudao} enablePreview /> : null}
                            </TableCell> */}

                            <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                            <TableCell align="right">
                              <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      <FormDialog title={action === "add" ? "添加联创" : "修改联创"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="用户" required sx={{ width: 800 }}>
          <Stack onClick={() => handleSelectUser("uid")}>
            <UserInfo {...user} enablePreview={false} />
          </Stack>
        </FormItem>

        <FormItem title="类型" required>
          <Select value={form.type} onChange={(e) => handleIptChange("type", e.target.value)} style={{ width: 250, height: 44 }}>
            {[1, 2].map((type, idx) => (
              <MenuItem key={idx} value={type} name={type}>
                {["", "合伙人", "代言人"][type]}
              </MenuItem>
            ))}
          </Select>
        </FormItem>

        <FormItem title="手机号" required>
          <TextField placeholder="手机号" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
        </FormItem>

        <FormItem title="姓名" required>
          <TextField placeholder="姓名" autoComplete="off" id="realname" value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
        </FormItem>
{/*
        <FormItem title="推荐人" sx={{ width: 800 }}>
          <Stack onClick={() => handleSelectUser("sharerUid")}>
            <UserInfo {...sharer} enablePreview={false} />
          </Stack>
        </FormItem> */}

        {/* <FormItem title="状态" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
            <FormControlLabel value={1} control={<Radio />} label="开启" onChange={(e) => handleIptChange("status", e.target.value)} />
            <FormControlLabel value={0} control={<Radio />} label="关闭" onChange={(e) => handleIptChange("status", e.target.value)} />
          </RadioGroup>
        </FormItem> */}
      </FormDialog>
    </Page>
  );
}
